import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'weightReport',
    label: 'Weight Report',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
